import { setPrototypeOf } from './polyfills/setPrototypeOf';

if (!Object.setPrototypeOf) {
  Object.setPrototypeOf = setPrototypeOf;
}
